//
// Module for the GL Account Assignments index view
//
rs.module("system/configuration/glaccountassignments/index",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, backendUrl) {
            var filter = $.js(jsSelectors.filter);
            var glSourceSelect = filter.js(jsSelectors.glSourceSelect);
            var glTransactionTypeSelect = filter.js(jsSelectors.glTransactionTypeSelect);
            var glTransactionTypeSelectHelper = selectHelper.getHelper(glTransactionTypeSelect);

            glSourceSelect.on("change", function () {
                $.getJSON(backendUrl, { glSource: glSourceSelect.val() }).done(function (data) {
                    glTransactionTypeSelectHelper.replaceOptions(data.list, { withBlank: true });
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);